module.exports = __webpack_public_path__ + "static/gss-logo-93d74a4d8266a09c0c19972315f75574.png";